import { render, staticRenderFns } from "./CollectionSelectDashboard.vue?vue&type=template&id=353b97a6&scoped=true&"
import script from "./CollectionSelectDashboard.vue?vue&type=script&lang=js&"
export * from "./CollectionSelectDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSelectDashboard.vue?vue&type=style&index=0&id=353b97a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b97a6",
  null
  
)

export default component.exports